export { AgeIcon } from "./age";
